import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiShoppingBag, FiUsers, FiPackage, FiSettings } from "react-icons/fi";
import "../styles/main.css";

const Sidebar = () => {
  const { pathname } = useLocation();
  const links = [
    { to: "/", label: "Dashboard", icon: <FiHome /> },
    { to: "/products", label: "Products", icon: <FiShoppingBag /> },
    { to: "/orders", label: "Orders", icon: <FiPackage /> },
    { to: "/users", label: "Users", icon: <FiUsers /> },
    // { to: "/settings", label: "Settings", icon: <FiSettings /> },
  ];

  return (
    <div className="sidebar">
<div className="sidebar-logo">
  <img 
    src="https://i.ibb.co/MwHMzcZ/Whats-App-Image-2025-08-05-at-10-30-04-AM-removebg-preview.png" 
    alt="SAC International" 
    className="sidebar-logo-img"
  />
</div>
      <nav>
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`sidebar-link ${pathname === link.to ? "active" : ""}`}
          >
            {link.icon}
            <span>{link.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
